
/**
 * CM post message API client. It allows to message commands to embedded CM iframe
 * which react accordingly. E.g. set filter
 * @param iframeElement {HTMLIFrameElement} element to which message commands to
 * @param hostUrl {URL} base host url of a iframe
 * @returns {Object}
 */
const messageClient = (iframeElement, hostUrl) => {

    /**
     * Add given filter instance to the given state defined with values
     * @param definitionId {Object} values to be filtered (Any other values will be filtered out)
     * @param values {Array<any>} values to be filtered (Any other values will be filtered out)
     * @param instanceId {string} Identifier of filter to be set
     */
    function addFilter(definitionId, values, instanceId) {
        send('filters/add', [definitionId, values, instanceId]);
    }

    /**
     * Set given filter to the given state defined with values and inverted parameters
     * @param instanceId {string} Identifier of filter to be set
     * @param values {Array<any>} values to be filtered (Any other values will be filtered out)
     */
    function setFilter(instanceId, values) {
        send('filters/set', [instanceId, values]);
    }

    /**
     * Reset given filter to the default state
     * Note: it is not the unfiltered state necessarily. It depends on Map view default filters set
     * @param instanceId {string} Identifier of filter to be reset
     */
    function resetFilter(instanceId) {
        send('filters/reset', [instanceId]);
    }

    /**
     * Remove given filter instance to the default state
     * @param instanceId {string} Identifier of filter to be reset
     */
    function removeFilter(instanceId) {
        send('filters/remove', [instanceId]);
    }

    /**
     * Open modal with bookmark creation dialog
     */
    function openBookmarkModal() {
        send('bookmark/open', []);
    }

    /**
     * Open modal with export options dialog
     */
    function openExportModal() {
        send('export/open', []);
    }

    /**
     * Toggle fit all
     */
    function toggleFitAll() {
        send('map/fitAll', []);
    }

    /**
     * Set embedding options
     */
    function setEmbeddingSettings(settings) {
        send('embedding/set', [settings]);
    }

    /**
     * Set access token
     */
    function setAccessToken(accessToken) {
        send('embedding/setAccessToken', [accessToken]);
    }

    function send(path, params) {
        iframeElement?.contentWindow?.postMessage({
            cmApiVersion: 1,
            path,
            params
        }, hostUrl.origin);
    }

    return {
        addFilter,
        setFilter,
        resetFilter,
        removeFilter,
        openBookmarkModal,
        openExportModal,
        toggleFitAll,
        setEmbeddingSettings,
        setAccessToken
    };
};

export default messageClient;
